module.exports = __webpack_public_path__ + "static/media/carriers-small-placeholder.e42990cd.webp";